import { memo, useCallback, useMemo, useRef, useState } from 'react';
import { Chip, Icon, SelectWrapper, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

const FontSizeSelector = ({ editor }) => {
    const theme = useTheme();
    const options = useMemo(
        () => [
            { label: getLiteral('label_default'), value: 'default' },
            {
                label: '10',
                value: 10,
            },
            {
                label: '12',
                value: 12,
            },
            {
                label: '14',
                value: 14,
            },
            {
                label: '16',
                value: 16,
            },
            {
                label: '18',
                value: 18,
            },
        ],
        [],
    );

    const [size, setSize] = useState(options[0]);
    const closePopoverRef = useRef(null);

    const onChange = useCallback(
        (payload) => {
            if (payload.value === 'default') {
                editor.commands.unsetFontSize();
            } else {
                editor.commands.setFontSize(`${payload.value}px`);
            }
            setSize(payload);

            // Close the popover after selecting
            setTimeout(() => {
                if (closePopoverRef.current) {
                    closePopoverRef.current();
                }
            }, 0);
        },
        [editor],
    );

    const onClose = useCallback(() => {
        closePopoverRef.current = null;
    }, []);

    const getIsOpen = useCallback((isOpen) => {
        if (!isOpen) {
            closePopoverRef.current = null;
        } else {
            // Save a function to close the popover
            closePopoverRef.current = () => {
                document.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
            };
        }
    }, []);

    const chipProps = useMemo(
        () => ({
            isUnfolded: true,
            className: 'fm-ee__editorToolbarChip',
        }),
        [],
    );

    const selectProps = useMemo(
        () => ({
            options,
            onChange,
            getIsOpen,
            onClose,
        }),
        [onChange, options, getIsOpen, onClose],
    );

    return (
        <SelectWrapper {...selectProps}>
            <Chip {...chipProps}>
                <Icon name="fontSize" color={theme.colors.actionMinor[500]} />
                {size.value !== 'default' && size.value}
            </Chip>
        </SelectWrapper>
    );
};

export default memo(FontSizeSelector);
